import { useState } from "react";
import { Login } from "@/components/Login";
import { Dashboard } from "@/components/Dashboard";
import { useAuth } from "@/contexts/AuthContext";

const Index = () => {
  const { user, isAuthenticated, isLoading } = useAuth();
  const [viewType, setViewType] = useState<"admin" | "client">("admin");

  const handleLogin = (_email: string, loginViewType: "admin" | "client") => {
    setViewType(loginViewType);
  };

  // Mostrar loading enquanto verifica autenticação
  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated || !user) {
    return <Login onLogin={handleLogin} />;
  }

  return <Dashboard viewType={viewType} />;
};

export default Index;
